<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="mini" v-model="formDatas.progressReimburse" clearable @change="partserch"
                        placeholder="报销进度" style="width: 100px">
                        <el-option label="未提交电子" :value="'option1'" key="option1"></el-option>
                        <el-option label="已完成(纸质+电子)" :value="'PPa3RnAVz'" key="PPa3RnAVz"></el-option>
                        <el-option label="报销电子提交" :value="'doing'" key="doing"></el-option>
                    </el-select>
                    <!-- <el-input v-model="formDatas.courseName" style="width: 120px;" size="mini" placeholder="课程名称"
                        clearable></el-input> -->
                    <el-input v-model="formDatas.projectName" style="width: 160px;" size="mini" placeholder="项目名称"
                        clearable></el-input>
                    <!-- <el-input v-model="formDatas.projectManage" style="width: 120px;" size="mini" placeholder="项目经理"
                        clearable></el-input> -->
                    <!-- <el-input v-model="formDatas.projectType" style="width: 100px;" size="mini" placeholder="项目分类"
                        clearable></el-input>
                    <el-input v-model="formDatas.courseSign" style="width: 100px;" size="mini" placeholder="课程标记"
                        clearable></el-input> -->
                    <el-date-picker v-model="formDatas.courseDateStart" type="date" value-format="yyyy-MM-dd"
                        placeholder="上课开始日期" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <span style="margin: 0 10px">-</span>
                    <el-date-picker v-model="formDatas.courseDateEnd" type="date" value-format="yyyy-MM-dd"
                        placeholder="开始日期" style="width: 110px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-select size="mini" v-model="formDatas.syncStatus" clearable @change="partserch"
                        placeholder="每刻同步" style="width: 100px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="失败" :value="3" key="3"></el-option>
                        <el-option label="不需要" :value="4" key="4"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.syncStatusZaitu" clearable @change="partserch"
                        placeholder="在途同步" style="width: 100px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="失败" :value="3" key="3"></el-option>
                        <el-option label="不需要" :value="4" key="4"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.syncStatusInit" clearable @change="partserch"
                        placeholder="初始化数据需要同步" style="width: 170px">
                        <el-option label="不需要" :value="2" key="2"></el-option>
                        <el-option label="需要" :value="1" key="1"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.syncStatusDidi" clearable @change="partserch"
                        placeholder="滴滴" style="width: 130px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="失败" :value="3" key="3"></el-option>
                        <el-option label="不需要" :value="4" key="4"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                        <el-button type="warning" size="mini" style="margin-left: 10px;" @click="BatchDisable">批量禁用</el-button>
                        <el-button type="primary" size="mini" style="margin-left: 10px;" @click="handleSyncLast" :loading="syncLoading">更新</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="fiId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>

        <!-- 详情 -->
        <el-dialog title="详情" :visible.sync="IsDetail" width="70%" top="8vh">
            <div>
                同步用户账号每刻:
                {{ DetailArr.fiSyncUserMeike }}
            </div>
            <div>
                同步用户账号在途:
                {{ DetailArr.fiSyncUserZaitu }}
            </div>
            <div style="max-height: 500px; overflow-y: scroll">
                <el-table :data="DetailArr.fxxkItineraryMeikeUserList" border highlight-current-row :header-cell-style="{
                    textAlign: 'center',
                    background: 'rgba(0,170,255,0.5)',
                    color: 'black',
                    border: 'none'
                }" style="width: 100%;margin:12px 0 0 0;">
                    <el-table-column label="纷享销客行程表记录id" align="center" prop="fiId">
                    </el-table-column>
                    <el-table-column label="用户id" align="center" prop="fmuId">
                    </el-table-column>
                     <el-table-column label="是否同步滴滴项目" align="center" prop="syncStatusDidiProject">
                    </el-table-column>
                    <el-table-column label="分享销客用户id" align="center" prop="openUserId">
                    </el-table-column>
                    <el-table-column label="用户名" align="center" prop="name">
                    </el-table-column>
                    <el-table-column label="账号" align="center" prop="account">
                    </el-table-column>
                    <el-table-column label="讲师id" align="center" prop="fmtId">
                    </el-table-column>
                    <el-table-column label="分享销客讲师id" align="center" prop="fmtFxxkId">
                    </el-table-column>
                    <el-table-column label="讲师名" align="center" prop="fmtName">
                    </el-table-column>
                    <el-table-column label="讲师授课名" align="center" prop="fmtNameSub">
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import { getFxxkItineraryMeikeList,getFxxkItineraryMeikeDetails,updateFxxkItineraryMeikeNotSync,updateFxxkItineraryMeikeSyncLast } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            IsDetail: false,
            DetailArr: '',
            key: 'fiId',
            dialog: false,
            edit: false,
            form: {
                appiName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                 {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "progressReimburse",
                    key: "progressReimburse",
                    title: "报销进度",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 100,
                },
                {
                    field: "courseName",
                    key: "courseName",
                    title: "课程名称",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 250,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    <el-tag on-click={() => this.openDetail(row)}>{row.courseName}</el-tag>
                                }
                            </span>
                        )
                    },
                },
                {
                    field: "projectName",
                    key: "projectName",
                    title: "项目名称",
                    align: "center",
                    edit: false,
                    width: 410,
                },
                {
                    field: "projectCoordination",
                    key: "projectCoordination",
                    title: "项目统筹",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "projectCoordinationId",
                    key: "projectCoordinationId",
                    title: "项目统筹",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "projectManage",
                    key: "projectManage",
                    title: "项目经理",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "projectManageId",
                    key: "projectManageId",
                    title: "项目经理",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fiNqAssistant",
                    key: "fiNqAssistant",
                    title: "独立助教",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fiNqAssistantId",
                    key: "fiNqAssistantId",
                    title: "独立助教",
                    align: "center",
                    edit: false,
                    width: 90,
                },

                {
                    field: "fiNqInternship",
                    key: "fiNqInternship",
                    title: "实习",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fiNqInternshipId",
                    key: "fiNqInternshipId",
                    title: "实习",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fiNqUserOther",
                    key: "fiNqUserOther",
                    title: "其他人员",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "fiNqUserOtherId",
                    key: "fiNqUserOtherId",
                    title: "其他人员",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "fiNqUserPart",
                    key: "fiNqUserPart",
                    title: "兼职人员",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fiNqUserPartId",
                    key: "fiNqUserPartId",
                    title: "兼职人员",
                    align: "center",
                    edit: false,
                    width: 90,
                },

                {
                    field: "projectOwner",
                    key: "projectOwner",
                    title: "负责人",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "projectOwnerId",
                    key: "projectOwnerId",
                    title: "负责人",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "projectTeacherCharges",
                    key: "projectTeacherCharges",
                    title: "讲师负责人合集",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "projectTeacherChargesId",
                    key: "projectTeacherChargesId",
                    title: "讲师负责人合集",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "courseTeachers",
                    key: "courseTeachers",
                    title: "上课老师合集",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "courseDateStartStr",
                    key: "courseDateStartStr",
                    title: "上课开始日期",
                    align: "center",
                    edit: false,
                    // fixed: 'left',
                    width: 90,
                },
                {
                    field: "courseDateEndStr",
                    key: "courseDateEndStr",
                    title: "上课结束日期",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "orderNum",
                    key: "orderNum",
                    title: "销售订单号",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "courseDaysTheory",
                    key: "courseDaysTheory",
                    title: "理论天数",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "courseDaysActual",
                    key: "courseDaysActual",
                    title: "实战天数",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "projectCustomer",
                    key: "projectCustomer",
                    title: "客户名称",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "projectMembers",
                    key: "projectMembers",
                    title: "团队成员合集",
                    align: "center",
                    edit: false,
                    width: 180,
                },
                {
                    field: "projectType",
                    key: "projectType",
                    title: "项目分类",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "courseSign",
                    key: "courseSign",
                    title: "课程标记",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "projectCharge",
                    key: "projectCharge",
                    title: "项目负责人",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "courseTeacherOne",
                    key: "courseTeacherOne",
                    title: "上课老师1",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "courseTeacherOneId",
                    key: "courseTeacherOneId",
                    title: "上课老师1",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "courseTeacherTwo",
                    key: "courseTeacherTwo",
                    title: "上课老师2",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "courseTeacherTwoId",
                    key: "courseTeacherTwoId",
                    title: "上课老师2",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "courseAssistantOne",
                    key: "courseAssistantOne",
                    title: "辅训老师1",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "courseAssistantOneId",
                    key: "courseAssistantOneId",
                    title: "辅训老师1",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "courseAssistantTwo",
                    key: "courseAssistantTwo",
                    title: "辅训老师2",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "courseAssistantTwoId",
                    key: "courseAssistantTwoId",
                    title: "辅训老师2",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "courseItineraryTeacher",
                    key: "courseItineraryTeacher",
                    title: "老师行程",
                    align: "center",
                    edit: false,
                    width: 360,
                },
                {
                    field: "courseItineraryAssistant",
                    key: "courseItineraryAssistant",
                    title: "辅训行程",
                    align: "center",
                    edit: false,
                    width: 360,
                },
                {
                    field: "courseItineraryUser",
                    key: "courseItineraryUser",
                    title: "员工行程",
                    align: "center",
                    edit: false,
                    width: 360,
                },
                {
                    field: "fiCreateTimeStr",
                    key: "fiCreateTimeStr",
                    title: "纷享创建时间",
                    align: "center",
                    edit: false,
                    // fixed: 'left',
                    width: 160,
                },
                {
                    field: "fiLastModifiedTimeStr",
                    key: "fiLastModifiedTimeStr",
                    title: "纷享最后修改时间",
                    align: "center",
                    edit: false,
                    // fixed: 'left',
                    width: 160,
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                { field: "updatetime", key: "cas", title: "修改时间", width: 160, align: "center" },
                {
                    field: "fiSyncUserMeike",
                    key: "fiSyncUserMeike",
                    title: "同步用户账号每刻",
                    width: 250,
                    align: "center",
                },
                {
                    field: "fiSyncUserZaitu",
                    key: "fiSyncUserZaitu",
                    title: "同步用户账号在途",
                    width: 250,
                    align: "center",
                },
                {
                    field: "syncStatus",
                    key: "syncStatus",
                    title: "每刻同步",
                    width: 90,
                    fixed: 'right',
                    align: "center",
                },
                {
                    field: "syncStatusZaitu",
                    key: "syncStatusZaitu",
                    title: "在途同步",
                    width: 90,
                    fixed: 'right',
                    align: "center",
                },
                {
                    field: "syncStatusDidi",
                    key: "syncStatusDidi",
                    title: "滴滴同步",
                    width: 90,
                    fixed: 'right',
                    align: "center",
                },
                {
                    field: "fiDataIdDidi",
                    key: "fiDataIdDidi",
                    title: "滴滴id",
                    width: 180,
                    fixed: 'right',
                    align: "center",
                },
                {
                    field: "syncStatusFailMsg",
                    key: "syncStatusFailMsg",
                    title: "同步失败信息",
                    width: 120,
                    align: "center",
                },
                {
                    field: "syncStatusInit",
                    key: "syncStatusInit",
                    title: "初始化数据",
                    width: 90,
                    fixed: 'right',
                    align: "center",
                },

            ], //表格的列
            tableData: [],
            syncLoading: false,
            post: null,
            formDatas: {
                progressReimburse: "",
                syncStatus: "",
                syncStatusZaitu: "",
                syncStatusInit: 1,
                courseName: '',
                projectName: '',
                projectManage: '',
                projectType: '',
                courseSign: '',
                courseDateStart: '',
                courseDateEnd: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        BatchDisable() {
            if(this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    type: "warning",
                    message: "请至少选择一行数据!",
                });
                return;
            }
            this.$confirm("是否批量禁用", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.openLoading();
                updateFxxkItineraryMeikeNotSync({fiIds:JSON.stringify(this.selectedRowKeysCollection)}).then((res) => {
                    this.selectedRowKeysCollection = [];
                    this.checkboxOption.selectedRowKeys = [];
                    this.partserch();
                    this.loadings.close();
                    // this.$message({
                    //   type: "success",
                    //   message: "搜索成功!",
                    // });
                });
            }).catch(() => { });
        },
        // 同步更新（接口耗时较长，页面级 loading 遮罩）
        handleSyncLast() {
            this.$confirm("确认执行同步更新操作？接口响应时间较长，请耐心等待。", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.syncLoading = true;
                const loading = this.$loading({
                    lock: true,
                    text: "同步更新中，请稍候...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                updateFxxkItineraryMeikeSyncLast().then((res) => {
                    this.$message({
                        type: "success",
                        message: "同步更新完成!",
                    });
                    this.partserch();
                }).catch(() => {
                    this.$message({
                        type: "error",
                        message: "同步更新失败，请重试!",
                    });
                }).finally(() => {
                    loading.close();
                    this.syncLoading = false;
                });
            }).catch(() => {});
        },
        openDetail(row) {
            getFxxkItineraryMeikeDetails({ fiId: row.fiId }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        handleDetail(row) {
            getFxxkItineraryDingtalkDetails({ fiId: row.fiId }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            })
        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getFxxkItineraryMeikeList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getFxxkItineraryMeikeList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getFxxkItineraryMeikeList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>